<span *ngIf="timeRemaining$ | async as timeRemaining">{{ timeRemaining | date: 'mm:ss' }}</span>
